import { Component, Input } from '@angular/core';

import { SnMessage, SnChatUser } from '../../../models';

@Component({
  selector: 'sn-message-view',
  templateUrl: './message-view.component.html',
  styleUrls: ['./message-view.component.scss'],
})
export class SnMessageViewComponent {
  @Input()
  get message(): SnMessage {
    return this._message;
  }
  set message(value: SnMessage) {
    this._message = value;
    this.isMedia = this._message.twilio.type === 'media';
    this.isCamera = this.message.twilio.attributes['type'] === 'camera';
    this.isMultiCameras = this.message.twilio.attributes['type'] === 'cameraList';
  }
  @Input() public isSystemMessage = false;
  @Input() public inherited = false;
  @Input() public author: SnChatUser;

  public isMedia: boolean;
  public isCamera: boolean;
  public isMultiCameras: boolean;

  private _message: SnMessage;

  constructor() {}
}
